webpackJsonp([5,35],{

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(7);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = new _vue2.default();

/***/ }),

/***/ 4:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(5),
	  /* template */
	  __webpack_require__(6),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _eventbus = __webpack_require__(2);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'btn',
	  props: {
	    name: {
	      type: String,
	      default: ''
	    },
	    theme: {
	      type: String,
	      default: 'default'
	    },
	    size: {
	      type: String,
	      default: 'default'
	    },
	    block: {
	      type: Boolean,
	      default: false
	    },
	    icon: {
	      type: String,
	      default: ''
	    },
	    disable: {
	      type: Boolean,
	      default: true
	    },
	    loading: {
	      type: Boolean,
	      default: false
	    },
	    submit: {
	      type: String,
	      default: ''
	    }
	  },
	  methods: {
	    handleClick: function handleClick() {
	      if (this.submit !== '') {
	        _eventbus2.default.$emit('btn-submit', this.submit);
	      }
	      if (this.disable && !this.loading) {
	        this.$emit('on-click', '');
	      }
	    }
	  },
	  data: function data() {
	    return {};
	  }
	};

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "btn",
	    class: [
	      'btn-' + _vm.theme,
	      'btn-' + _vm.size,
	      _vm.block ? 'btn-block' : ''
	    ],
	    on: {
	      "click": _vm.handleClick
	    }
	  }, [(_vm.icon != '' && !_vm.loading) ? _c('i', {
	    staticClass: "icon iconfont",
	    class: [_vm.icon ? 'icon-' + _vm.icon : '']
	  }) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('i', {
	    staticClass: "icon iconfont icon-loading loading"
	  }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.name))])])
	},staticRenderFns: []}

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

	'use strict';
	
	var Format = {
	  type: {
	    required: {
	      reg: /.{1,}/,
	      msg: '此项不能为空'
	    },
	    email: {
	      reg: /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/,
	      msg: '邮箱格式错误'
	    },
	    phone: {
	      reg: /^\d{11}$/,
	      msg: '手机格式错误'
	    },
	    float: {
	      reg: /^\d+(.\d+)?$/,
	      msg: '必须为整数或小数'
	    },
	    int: {
	      reg: /^\d+$/,
	      msg: '必须为整数'
	    }
	  },
	  do: function _do(required, format, value) {
	    var _this = this;
	    var pass = { state: true, msg: '' };
	    try {
	      if (typeof value === 'string') {
	        var value = value.replace(/\s/, '');
	      }
	    } catch (e) {
	      return {
	        state: false,
	        msg: '验证发生错误'
	      };
	    }
	
	    if (required) {
	      if (!_this.type.required.reg.test(value)) {
	        return {
	          state: false,
	          msg: _this.type.required.msg
	        };
	      }
	    }
	
	    if (typeof format === 'string') {
	      var tester = _this.type[format];
	    } else {
	      var tester = format;
	    }
	
	    if (tester == undefined) {
	      return pass;
	    }
	
	    if (tester.reg.test(value)) {
	      return pass;
	    } else {
	      if (value == '') {
	        return pass;
	      }
	      return {
	        state: false,
	        msg: tester.msg
	      };
	    }
	  }
	};
	
	module.exports = Format;

/***/ }),

/***/ 9:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _format = __webpack_require__(8);
	
	var _format2 = _interopRequireDefault(_format);
	
	var _eventbus = __webpack_require__(2);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'formInput',
	  props: {
	    type: {
	      type: String,
	      default: 'text'
	    },
	    name: {
	      type: String,
	      default: ''
	    },
	    value: {
	      default: ''
	    },
	    theme: {
	      type: String,
	      default: 'default' },
	    size: {
	      type: String,
	      default: 'default'
	    },
	    icon: {
	      type: String,
	      default: ''
	    },
	    state: {
	      type: String,
	      default: 'normal' },
	    enable: {
	      type: Boolean,
	      default: true
	    },
	    holder: {
	      type: String,
	      default: ''
	    },
	    required: {
	      type: Boolean,
	      default: false
	    },
	    format: {
	      type: String,
	      default: ''
	    },
	    label: {
	      type: String,
	      default: ''
	    },
	    for: {
	      type: String,
	      default: ''
	    },
	    focus: {
	      type: Boolean,
	      default: false
	    }
	  },
	  methods: {
	    getValue: function getValue() {
	      return this.valueSelf;
	    },
	    setState: function setState(state) {
	      this.stateSelf = state;
	    },
	    verify: function verify() {
	      var check = _format2.default.do(this.required, this.format, this.valueSelf);
	      if (check.state) {
	        this.setState('');
	      } else {
	        this.setState('wrong');
	      }
	      return check;
	    },
	    formVerify: function formVerify(formid) {
	      if (this.for === formid) {
	        _eventbus2.default.$emit('input-verify', {
	          formid: formid,
	          result: this.verify(),
	          data: {
	            name: this.name,
	            value: this.valueSelf
	          }
	        });
	      }
	    },
	    handleClick: function handleClick() {
	      this.$emit('on-click', '');
	    }
	  },
	  created: function created() {
	    _eventbus2.default.$on('form-verify', this.formVerify);
	  },
	  beforeDestroy: function beforeDestroy() {
	    _eventbus2.default.$off('form-verify', this.formVerify);
	  },
	  mounted: function mounted() {
	    if (this.focus) {
	      this.$refs.input.focus();
	    }
	  },
	
	  watch: {
	    value: function value(newval) {
	      this.valueSelf = newval;
	    },
	    valueSelf: function valueSelf(newval) {
	      this.$emit('input', newval);
	    }
	  },
	  data: function data() {
	    return {
	      valueSelf: this.value,
	      stateSelf: this.state
	    };
	  }
	};

/***/ }),

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(9),
	  /* template */
	  __webpack_require__(11),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 11:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.label != '') ? _c('div', {
	    staticClass: "form-item",
	    class: [
	      'form-item-' + this.theme
	    ],
	    on: {
	      "click": _vm.handleClick
	    }
	  }, [_c('label', {
	    class: ['label-' + this.size],
	    attrs: {
	      "for": _vm.name
	    }
	  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('div', {
	    class: [
	      'be-' + _vm.stateSelf,
	      _vm.icon != '' ? 'has-icon' : ''
	    ]
	  }, [(_vm.type == 'text') ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.valueSelf),
	      expression: "valueSelf"
	    }],
	    ref: "input",
	    staticClass: "input form-control",
	    class: [
	      'input-' + this.size,
	      'input-' + this.theme
	    ],
	    attrs: {
	      "type": "text",
	      "name": _vm.name,
	      "placeholder": _vm.holder,
	      "disabled": !_vm.enable
	    },
	    domProps: {
	      "value": (_vm.valueSelf)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.valueSelf = $event.target.value
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.type == 'password') ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.valueSelf),
	      expression: "valueSelf"
	    }],
	    ref: "input",
	    staticClass: "input form-control",
	    class: [
	      'input-' + this.size,
	      'input-' + this.theme
	    ],
	    attrs: {
	      "type": "password",
	      "name": _vm.name,
	      "placeholder": _vm.holder,
	      "disabled": !_vm.enable
	    },
	    domProps: {
	      "value": (_vm.valueSelf)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.valueSelf = $event.target.value
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.icon != '') ? _c('i', {
	    staticClass: "icon iconfont",
	    class: ['icon-' + _vm.icon]
	  }) : _vm._e()])]) : _c('div', {
	    staticClass: "form-item",
	    class: [
	      'be-' + _vm.stateSelf,
	      _vm.icon != '' ? 'has-icon' : ''
	    ],
	    on: {
	      "click": _vm.handleClick
	    }
	  }, [(_vm.type == 'text') ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.valueSelf),
	      expression: "valueSelf"
	    }],
	    ref: "input",
	    staticClass: "input form-control",
	    class: [
	      'input-' + this.size,
	      this.theme == 'underline' ? 'input-' + this.theme : ''
	    ],
	    attrs: {
	      "type": "text",
	      "name": _vm.name,
	      "placeholder": _vm.holder,
	      "disabled": !_vm.enable
	    },
	    domProps: {
	      "value": (_vm.valueSelf)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.valueSelf = $event.target.value
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.type == 'password') ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.valueSelf),
	      expression: "valueSelf"
	    }],
	    ref: "input",
	    staticClass: "input form-control",
	    class: [
	      'input-' + this.size,
	      this.theme == 'underline' ? 'input-' + this.theme : ''
	    ],
	    attrs: {
	      "type": "password",
	      "name": _vm.name,
	      "placeholder": _vm.holder,
	      "disabled": !_vm.enable
	    },
	    domProps: {
	      "value": (_vm.valueSelf)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.valueSelf = $event.target.value
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.icon != '') ? _c('i', {
	    staticClass: "icon iconfont",
	    class: ['icon-' + _vm.icon]
	  }) : _vm._e()])
	},staticRenderFns: []}

/***/ }),

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(134),
	  /* template */
	  __webpack_require__(265),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(40);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _phoneCode = __webpack_require__(205);
	
	var _phoneCode2 = _interopRequireDefault(_phoneCode);
	
	var _btn = __webpack_require__(4);
	
	var _btn2 = _interopRequireDefault(_btn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'codedemo',
	  components: {
	    phoneCode: _phoneCode2.default,
	    Btn: _btn2.default
	  },
	  created: function created() {},
	
	  methods: {
	    sendCode: function sendCode(phone) {
	      alert('发送验证码到' + phone);
	    },
	    submit: function submit() {
	      alert((0, _stringify2.default)(this.$refs.code.getValue()));
	    }
	  },
	  data: function data() {
	    return {};
	  }
	};

/***/ }),

/***/ 135:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _btn = __webpack_require__(4);
	
	var _btn2 = _interopRequireDefault(_btn);
	
	var _boInput = __webpack_require__(10);
	
	var _boInput2 = _interopRequireDefault(_boInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'codedemo',
	  components: {
	    Btn: _btn2.default,
	    BoInput: _boInput2.default
	  },
	  props: {
	    seconds: {
	      type: Number,
	      default: 60
	    },
	    phone: {
	      default: ''
	    },
	    phoneMode: {
	      type: String,
	      default: 'default' }
	  },
	  created: function created() {},
	
	  methods: {
	    checkPhone: function checkPhone() {
	      if (this.$refs.phone.verify().state) {
	        return true;
	      }
	      return false;
	    },
	    runClock: function runClock() {
	      var _this = this;
	
	      if (!this.lock) {
	        this.lock = true;
	        this.timer = setInterval(function () {
	          if (_this.clock > 0) {
	            _this.clock -= 1;
	          }
	          if (_this.clock === 0) {
	            _this.lock = false;
	            _this.clock = _this.seconds;
	            clearInterval(_this.timer);
	          }
	        }, 1000);
	        return true;
	      }
	      return false;
	    },
	    sendCode: function sendCode() {
	      if (this.checkPhone()) {
	        if (this.runClock()) {
	          this.$emit('on-send', this.phoneSelf);
	        }
	      }
	    },
	    getValue: function getValue() {
	      return {
	        phone: this.phoneSelf,
	        code: this.code
	      };
	    }
	  },
	  watch: {
	    phone: function phone(newval) {
	      this.phoneSelf = newval;
	    }
	  },
	  data: function data() {
	    return {
	      phoneSelf: this.phone,
	      code: '',
	      lock: false,
	      clock: this.seconds,
	      timer: null
	    };
	  }
	};

/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(135),
	  /* template */
	  __webpack_require__(229),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 229:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('bo-input', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.phoneMode != 'hide'),
	      expression: "phoneMode!='hide'"
	    }],
	    ref: "phone",
	    attrs: {
	      "holder": "输入手机号",
	      "size": "lg",
	      "label": "手机号",
	      "theme": "blank",
	      "format": "phone",
	      "required": true,
	      "enable": _vm.phoneMode != 'disable'
	    },
	    model: {
	      value: (_vm.phoneSelf),
	      callback: function($$v) {
	        _vm.phoneSelf = $$v
	      },
	      expression: "phoneSelf"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "form-item form-item-blank form-code"
	  }, [_c('label', {
	    staticClass: "label-lg",
	    attrs: {
	      "for": ""
	    }
	  }, [_vm._v("验证码")]), _vm._v(" "), _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.code),
	      expression: "code"
	    }],
	    staticClass: "input input-lg form-control rbb",
	    attrs: {
	      "type": "text",
	      "name": "name",
	      "value": "",
	      "placeholder": "请输入内容"
	    },
	    domProps: {
	      "value": (_vm.code)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.code = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "form-code-btn"
	  }, [_c('button', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.lock),
	      expression: "lock"
	    }],
	    staticClass: "btn btn-code input-lg",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v(_vm._s(_vm.clock) + "秒后重发")]), _vm._v(" "), _c('button', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.lock),
	      expression: "!lock"
	    }],
	    staticClass: "btn btn-code input-lg",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.sendCode
	    }
	  }, [_vm._v("获取验证码")])])])], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 265:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {}, [_c('div', {
	    staticClass: "form-blank m2000"
	  }, [_c('phone-code', {
	    ref: "code",
	    on: {
	      "on-send": _vm.sendCode
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "p2222"
	  }, [_c('btn', {
	    attrs: {
	      "name": "获取输入",
	      "theme": "primary",
	      "block": true,
	      "size": "lg"
	    },
	    on: {
	      "on-click": _vm.submit
	    }
	  })], 1)])
	},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/5.5d167406bbaf8b5693c3.js